import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/authContext'
import IsPageUseful from '../IsPageUseful'
import Newsletter from '../Newsletter'
import HomePageChangelog from './HomePageChangelog'
import HomePageCta from './HomePageCta'
import HomePageDevelopmentTools from './HomePageDevelopmentTools'
import HomePageDocumentation from './HomePageDocumentation'
import HomePageGreeting from './HomePageGreeting'
import HomePageUseCases from './HomePageUseCases'

const HomePage = ({ data, location }) => {
  const { user } = useContext(AuthContext)

  return (
    <>
      <HomePageGreeting userName={user?.profile?.name} />
      {user && <HomePageDevelopmentTools />}
      <HomePageDocumentation />
      <HomePageUseCases />
      {!user && <HomePageCta />}
      <HomePageChangelog data={data} />

      <IsPageUseful url={location.href} />
      {!user && <Newsletter />}
    </>
  )
}

export default HomePage
